// ========== FILE: shop-enhancer-core.js ==========
// ✅ Shared utility functions used across multiple features (wishlist, cart...)

window.shopEnhancer = window.shopEnhancer || {};

// ✅ Update cart bubble count
window.shopEnhancer.updateCartCount = function () {
  fetch("/cart.js")
    .then((res) => res.json())
    .then((cart) => {
      const countBubble = document.querySelector(".cart-count-bubble");
      if (countBubble) {
        countBubble.textContent = cart.item_count;
       countBubble.classList.toggle("hidden", cart.item_count === 0);
      }
    });     
};

// ✅ Update wishlist count in the header
window.shopEnhancer.updateWishlistCount = function () {
  const wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
  const count = wishlist.length;
  const badge = document.querySelector(".wishlist-count-bubble span[aria-hidden='true']");
  const srText = document.querySelector(".wishlist-count-bubble .visually-hidden");

  if (badge) badge.textContent = count;
  if (srText) srText.textContent = `${count} item${count !== 1 ? "s" : ""} in wishlist`;

  const container = document.querySelector(".wishlist-count-bubble");
  if (container) {
    container.style.display = count === 0 ? "none" : "flex";
  }
};

//Event fix
/*
// ✅ Init quick add icons (ensure only once per element)
window.shopEnhancer.initQuickAddIcons = function (scope = document) {
  scope.querySelectorAll('.add-to-cart_new:not([data-bound])').forEach((btn) => {
    btn.dataset.bound = 'true';
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const handle = btn.dataset.handle;
      if (handle && typeof window.shopEnhancer.addToCartByHandle === 'function') {
        window.shopEnhancer.addToCartByHandle(handle);
      }
     }, { once: true }); // Optional:avoid duplicate bind
  });
};
*/
/*
// ✅ Init quick add icons (ensure only once per element) //fix use  data-variant-id
window.shopEnhancer.initQuickAddIcons = function (scope = document) {
  scope.querySelectorAll('.add-to-cart_new:not([data-bound])').forEach((btn) => {
    btn.dataset.bound = 'true';
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      e.stopPropagation();

      const variantId = btn.dataset.variantId;
      if (!variantId) {
        console.error("Quick Add: missing data-variant-id");
        return;
      }
     console.log("Quick Add — variantId:", variantId);
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
        if (!res.ok) throw new Error(`Add to cart failed: ${res.status}`);
        await res.json();

        //Update badge cart
        window.shopEnhancer.updateCartCount();

        // If showToast
        if (typeof showToast === 'function') {
          showToast("Added to cart!");
        }
      } catch (err) {
        console.error("Quick Add Error:", err);
      }
    }, { once: true }); // still use once if you want
  });
};


// ✅ Init wishlist icons (ensure only once per element)
window.shopEnhancer.initWishlistIcons = function (scope = document) {
  scope.querySelectorAll('.add-to-wishlist:not([data-bound])').forEach((btn) => {
    btn.dataset.bound = 'true';
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const handle = btn.dataset.handle;
      if (handle && typeof window.shopEnhancer.toggleWishlist === 'function') {
        window.shopEnhancer.toggleWishlist(handle);
      }
      }, { once: true }); // Optional: avoid duplicate bind
  });
};
*/
//Using data-initialized="true" is more common and clear.
// COMBINE into single standard (quick add + wishlist):
window.shopEnhancer.initQuickAddIcons = function (scope = document) {
  scope.querySelectorAll(".add-to-cart_new:not([data-initialized])").forEach((btn) => {
    btn.dataset.initialized = "true";
    btn.addEventListener("click", async (e) => {
      e.preventDefault();
      e.stopPropagation();
      const variantId = btn.dataset.variantId;
      if (!variantId) return console.error("Missing variantId");

      try {
        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: variantId, quantity: 1 }),
        });
        if (!res.ok) throw new Error("Add to cart failed");
        await res.json();
        window.shopEnhancer.updateCartCount();
        if (typeof showToast === "function") showToast("✅ Added to cart!");
      } catch (err) {
        console.error("Add to cart error", err);
      }
    });
  });
};

window.shopEnhancer.initWishlistIcons = function (scope = document) {
  scope.querySelectorAll("[data-wishlist-button]:not([data-initialized])").forEach((btn) => {
    btn.dataset.initialized = "true";
    btn.addEventListener("click", () => {
      const productId = btn.dataset.productId;
      window.shopEnhancer.toggleWishlist(productId);
    });
  });
};

/* MutationObserver use section, #id, .class 
window.shopEnhancer.observeAndInit('product-recommendations');
*/
// Function to re-initialize icon and badge
window.shopEnhancer.reInitIcons = function (scope = document) {
  window.shopEnhancer.initQuickAddIcons?.(scope);
  window.shopEnhancer.initWishlistIcons?.(scope);
  window.shopEnhancer.updateWishlistCount?.();
  window.shopEnhancer.updateCartCount?.();
};

// The function automatically observes a section to re-init the icon whenever the DOM changes.
window.shopEnhancer.observeAndInit = function (sectionSelector) {
  const run = (section) => {
    if (section) {
      console.log(`🔁 Init icons for ${sectionSelector}`);
      window.shopEnhancer.reInitIcons(section);
    }
  };

  // Catch Shopify custom events (if any)
  document.addEventListener(`${sectionSelector.replace(/[-]/g, '_')}:loaded`, (event) => {
    run(event?.target);
  });

  // Fallback after 1s if loaded with Liquid
  setTimeout(() => {
    const section = document.querySelector(sectionSelector);
    run(section);

    // FIX: Only observe section if it exists
    if (section) {
      const observer = new MutationObserver(() => {
        run(section);
      });

      // FIX: Only observe the target section instead of the whole body
      observer.observe(section, { childList: true, subtree: true });
    }
  }, 1000);

  // FIX: Removed observation on document.body to avoid over-triggering
};



